import React from "react";
import ReactDOM from "react-dom";

// Tailwind CSS - must be imported before components
import "./index.css";

import App from "./App";

ReactDOM.render(
  <App />,
  document.getElementById("root")
);
